import { render, staticRenderFns } from "./NewsSingleHeader.vue?vue&type=template&id=734fd2fd&"
import script from "./NewsSingleHeader.vue?vue&type=script&lang=js&"
export * from "./NewsSingleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports